import { InviteView, RoleBody, UserInviteParams, UserView } from '@lemoncloud/codes-backend-api';
import { OwnerView } from '@lemoncloud/codes-goods-api';
import { Params } from '@lemoncloud/lemon-web-core';

import { ListResult } from '@codes/shared';
import { webCore } from '@codes/web-core';

const BACKEND_ENDPOINT = import.meta.env.VITE_BACKEND_ENDPOINT.toLowerCase();
const OAUTH_ENDPOINT = import.meta.env.VITE_OAUTH_ENDPOINT.toLowerCase();

export const fetchOwner = async (params: Params = {}): Promise<OwnerView> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BACKEND_ENDPOINT}/owners/0/profile`,
        })
        .setParams({ ...params })
        .execute<OwnerView>();

    return data;
};

export const fetchOwners = async (params: Params = {}): Promise<ListResult<OwnerView>> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${BACKEND_ENDPOINT}/owners/0/list`,
        })
        .setParams({ ...params })
        .execute<ListResult<OwnerView>>();

    return data;
};

export const fetchTeamMembers = async (params: Params): Promise<ListResult<UserView>> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'GET',
            baseURL: `${OAUTH_ENDPOINT}/sites/0/users`,
        })
        .setParams({ ...params })
        .execute<ListResult<UserView>>();

    return data;
};

export const updateMemberRole = async (roleBody: RoleBody): Promise<UserView> => {
    if (!roleBody.id) {
        throw new Error('refuseMember: @roleBody.id is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'PUT',
            baseURL: `${OAUTH_ENDPOINT}/users/${roleBody.id}/role`,
        })
        .setBody({ ...roleBody })
        .execute<UserView>();

    return data;
};

export const inviteMember = async (userInviteParams: UserInviteParams): Promise<InviteView> => {
    const { data } = await webCore
        .buildSignedRequest({
            method: 'POST',
            baseURL: `${OAUTH_ENDPOINT}/users/0/invite`,
        })
        .setParams({ email: 1, expires: 30 })
        .setBody({ ...userInviteParams })
        .execute<InviteView>();

    return data;
};

export const refuseMember = async (userId: string): Promise<UserView> => {
    if (!userId) {
        throw new Error('refuseMember: @userId is required');
    }

    const { data } = await webCore
        .buildSignedRequest({
            method: 'PUT',
            baseURL: `${OAUTH_ENDPOINT}/users/${userId}/role`,
        })
        .setBody({ role: '' })
        .execute<UserView>();

    return data;
};
